module.exports = __webpack_public_path__ + "img/zap.b7e22c06.svg";